import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from '../components/layout'
import aboutStyle from "../components/styles/about.module.scss"
import facebook from "../images/facebook.png"
import twitter from "../images/twitter.png"
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'

const About = () => {
const data = useStaticQuery(graphql`
query {
  allContentfulAboutUs {
    edges {
      node {
        arifAlviLogo {
          file {
            url
          }
          
        }
        body {
          json
        }
        title
          discription{
            discription
          }
      }
    }
  }
}
`)
  return (
    <Layout>
      <div className={aboutStyle.container}>
      <div className={aboutStyle.imgDiv}>
        <div className={aboutStyle.imgOuterDiv}>
          <img
            src={data.allContentfulAboutUs.edges[0].node.arifAlviLogo[0].file.url}
            alt="pic of President"
            className={aboutStyle.logo}
          ></img>
        </div>
        <div className={aboutStyle.title}>
  <h2>{data.allContentfulAboutUs.edges[0].node.title}</h2>
        </div>
        <div className={aboutStyle.description}>
          <p>
          {data.allContentfulAboutUs.edges[0].node.discription.discription}
          </p>
        </div>
        <div className={aboutStyle.socialMain}>
          <div>
            <img src={facebook} alt="facbook logo" className={aboutStyle.socialImg}></img>
          </div>
          <div>
            <img src={twitter} alt="twitterLogo" className={aboutStyle.socialImg}></img>
          </div>
        </div>
      </div>
      <div className={aboutStyle.aboutMain}>
        <p className={aboutStyle.aboutDesc}>
        {documentToReactComponents(data.allContentfulAboutUs.edges[0].node.body.json)}
          
        </p>
      </div>
      </div>
      </Layout>
      
  )
}

export default About
